import ym from 'react-yandex-metrika';

const isProd = process.env.NODE_ENV === 'production';

export const widgetButtonClickTrack = () => {
  return isProd && ym('reachGoal', 'Виджет еОСАГО новый');
};

export const tabOpenTrack = () => {
  return isProd && ym('reachGoal', 'Тап еОСАГО');
};
